import {
  CDLLayer,
  CDL_YEARS,
  GeopoliticalLayer,
  LayerContext,
  MapStyles,
  SatelliteLayer,
  useViewportContext,
} from '@cibo/mapgl'
import { useContext } from 'react'

export const InventoryMapLayers = () => {
  const {
    viewport: { zoom },
  } = useViewportContext()
  const { mapStyle } = useContext(LayerContext)
  return (
    <>
      <GeopoliticalLayer states hideSelectedGeometries counties={false} townships={false} />
      <SatelliteLayer show={mapStyle === MapStyles.SATELLITE} />
      {CDL_YEARS.map(year => (
        <CDLLayer key={year} year={year} />
      ))}
      <GeopoliticalLayer
        states={zoom <= 6}
        counties={zoom > 6}
        townships={false}
        hideSelectedGeometries
      />

      {CDL_YEARS.map(year => (
        <CDLLayer key={year} year={year} />
      ))}
    </>
  )
}
